export let cat = "miaw"
export let data = [
  {
    "sex": "Female",
    "age": "65-69",
    "category": "Living in a couple",
    "type": "Bad or very bad health",
    "value": 0.072
  },
  {
    "sex": "Female",
    "age": "70-74",
    "category": "Living in a couple",
    "type": "Bad or very bad health",
    "value": 0.078
  },
  {
    "sex": "Female",
    "age": "75-79",
    "category": "Living in a couple",
    "type": "Bad or very bad health",
    "value": 0.101
  },
  {
    "sex": "Female",
    "age": "80-84",
    "category": "Living in a couple",
    "type": "Bad or very bad health",
    "value": 0.142
  },
  {
    "sex": "Female",
    "age": "85-89",
    "category": "Living in a couple",
    "type": "Bad or very bad health",
    "value": 0.195
  },
  {
    "sex": "Female",
    "age": "90+",
    "category": "Living in a couple",
    "type": "Bad or very bad health",
    "value": 0.258
  },
  {
    "sex": "Male",
    "age": "65-69",
    "category": "Living in a couple",
    "type": "Bad or very bad health",
    "value": 0.079
  },
  {
    "sex": "Male",
    "age": "70-74",
    "category": "Living in a couple",
    "type": "Bad or very bad health",
    "value": 0.085
  },
  {
    "sex": "Male",
    "age": "75-79",
    "category": "Living in a couple",
    "type": "Bad or very bad health",
    "value": 0.108
  },
  {
    "sex": "Male",
    "age": "80-84",
    "category": "Living in a couple",
    "type": "Bad or very bad health",
    "value": 0.142
  },
  {
    "sex": "Male",
    "age": "85-89",
    "category": "Living in a couple",
    "type": "Bad or very bad health",
    "value": 0.186
  },
  {
    "sex": "Male",
    "age": "90+",
    "category": "Living in a couple",
    "type": "Bad or very bad health",
    "value": 0.232
  },
  {
    "sex": "Female",
    "age": "65-69",
    "category": "Living in a couple",
    "type": "Fair health",
    "value": 0.195
  },
  {
    "sex": "Female",
    "age": "70-74",
    "category": "Living in a couple",
    "type": "Fair health",
    "value": 0.232
  },
  {
    "sex": "Female",
    "age": "75-79",
    "category": "Living in a couple",
    "type": "Fair health",
    "value": 0.283
  },
  {
    "sex": "Female",
    "age": "80-84",
    "category": "Living in a couple",
    "type": "Fair health",
    "value": 0.348
  },
  {
    "sex": "Female",
    "age": "85-89",
    "category": "Living in a couple",
    "type": "Fair health",
    "value": 0.411
  },
  {
    "sex": "Female",
    "age": "90+",
    "category": "Living in a couple",
    "type": "Fair health",
    "value": 0.443
  },
  {
    "sex": "Male",
    "age": "65-69",
    "category": "Living in a couple",
    "type": "Fair health",
    "value": 0.208
  },
  {
    "sex": "Male",
    "age": "70-74",
    "category": "Living in a couple",
    "type": "Fair health",
    "value": 0.242
  },
  {
    "sex": "Male",
    "age": "75-79",
    "category": "Living in a couple",
    "type": "Fair health",
    "value": 0.286
  },
  {
    "sex": "Male",
    "age": "80-84",
    "category": "Living in a couple",
    "type": "Fair health",
    "value": 0.335
  },
  {
    "sex": "Male",
    "age": "85-89",
    "category": "Living in a couple",
    "type": "Fair health",
    "value": 0.389
  },
  {
    "sex": "Male",
    "age": "90+",
    "category": "Living in a couple",
    "type": "Fair health",
    "value": 0.428
  },
  {
    "sex": "Female",
    "age": "65-69",
    "category": "Living in a couple",
    "type": "Very good or good health",
    "value": 0.733
  },
  {
    "sex": "Female",
    "age": "70-74",
    "category": "Living in a couple",
    "type": "Very good or good health",
    "value": 0.69
  },
  {
    "sex": "Female",
    "age": "75-79",
    "category": "Living in a couple",
    "type": "Very good or good health",
    "value": 0.616
  },
  {
    "sex": "Female",
    "age": "80-84",
    "category": "Living in a couple",
    "type": "Very good or good health",
    "value": 0.51
  },
  {
    "sex": "Female",
    "age": "85-89",
    "category": "Living in a couple",
    "type": "Very good or good health",
    "value": 0.394
  },
  {
    "sex": "Female",
    "age": "90+",
    "category": "Living in a couple",
    "type": "Very good or good health",
    "value": 0.3
  },
  {
    "sex": "Male",
    "age": "65-69",
    "category": "Living in a couple",
    "type": "Very good or good health",
    "value": 0.713
  },
  {
    "sex": "Male",
    "age": "70-74",
    "category": "Living in a couple",
    "type": "Very good or good health",
    "value": 0.673
  },
  {
    "sex": "Male",
    "age": "75-79",
    "category": "Living in a couple",
    "type": "Very good or good health",
    "value": 0.606
  },
  {
    "sex": "Male",
    "age": "80-84",
    "category": "Living in a couple",
    "type": "Very good or good health",
    "value": 0.523
  },
  {
    "sex": "Male",
    "age": "85-89",
    "category": "Living in a couple",
    "type": "Very good or good health",
    "value": 0.425
  },
  {
    "sex": "Male",
    "age": "90+",
    "category": "Living in a couple",
    "type": "Very good or good health",
    "value": 0.34
  },
  {
    "sex": "Female",
    "age": "65-69",
    "category": "Living alone",
    "type": "Bad or very bad health",
    "value": 0.13
  },
  {
    "sex": "Male",
    "age": "65-69",
    "category": "Living alone",
    "type": "Bad or very bad health",
    "value": 0.16
  },
  {
    "sex": "Female",
    "age": "70-74",
    "category": "Living alone",
    "type": "Bad or very bad health",
    "value": 0.11
  },
  {
    "sex": "Male",
    "age": "70-74",
    "category": "Living alone",
    "type": "Bad or very bad health",
    "value": 0.14
  },
  {
    "sex": "Female",
    "age": "75-79",
    "category": "Living alone",
    "type": "Bad or very bad health",
    "value": 0.12
  },
  {
    "sex": "Male",
    "age": "75-79",
    "category": "Living alone",
    "type": "Bad or very bad health",
    "value": 0.14
  },
  {
    "sex": "Female",
    "age": "80-84",
    "category": "Living alone",
    "type": "Bad or very bad health",
    "value": 0.14
  },
  {
    "sex": "Male",
    "age": "80-84",
    "category": "Living alone",
    "type": "Bad or very bad health",
    "value": 0.16
  },
  {
    "sex": "Female",
    "age": "85-89",
    "category": "Living alone",
    "type": "Bad or very bad health",
    "value": 0.18
  },
  {
    "sex": "Male",
    "age": "85-89",
    "category": "Living alone",
    "type": "Bad or very bad health",
    "value": 0.18
  },
  {
    "sex": "Female",
    "age": "90+",
    "category": "Living alone",
    "type": "Bad or very bad health",
    "value": 0.21
  },
  {
    "sex": "Male",
    "age": "90+",
    "category": "Living alone",
    "type": "Bad or very bad health",
    "value": 0.2
  },
  {
    "sex": "Female",
    "age": "65-69",
    "category": "Living alone",
    "type": "Fair health",
    "value": 0.25
  },
  {
    "sex": "Male",
    "age": "65-69",
    "category": "Living alone",
    "type": "Fair health",
    "value": 0.29
  },
  {
    "sex": "Female",
    "age": "70-74",
    "category": "Living alone",
    "type": "Fair health",
    "value": 0.27
  },
  {
    "sex": "Male",
    "age": "70-74",
    "category": "Living alone",
    "type": "Fair health",
    "value": 0.31
  },
  {
    "sex": "Female",
    "age": "75-79",
    "category": "Living alone",
    "type": "Fair health",
    "value": 0.31
  },
  {
    "sex": "Male",
    "age": "75-79",
    "category": "Living alone",
    "type": "Fair health",
    "value": 0.34
  },
  {
    "sex": "Female",
    "age": "80-84",
    "category": "Living alone",
    "type": "Fair health",
    "value": 0.37
  },
  {
    "sex": "Male",
    "age": "80-84",
    "category": "Living alone",
    "type": "Fair health",
    "value": 0.37
  },
  {
    "sex": "Female",
    "age": "85-89",
    "category": "Living alone",
    "type": "Fair health",
    "value": 0.42
  },
  {
    "sex": "Male",
    "age": "85-89",
    "category": "Living alone",
    "type": "Fair health",
    "value": 0.41
  },
  {
    "sex": "Female",
    "age": "90+",
    "category": "Living alone",
    "type": "Fair health",
    "value": 0.47
  },
  {
    "sex": "Male",
    "age": "90+",
    "category": "Living alone",
    "type": "Fair health",
    "value": 0.45
  },
  {
    "sex": "Female",
    "age": "65-69",
    "category": "Living alone",
    "type": "Very good or good health",
    "value": 0.62
  },
  {
    "sex": "Male",
    "age": "65-69",
    "category": "Living alone",
    "type": "Very good or good health",
    "value": 0.55
  },
  {
    "sex": "Female",
    "age": "70-74",
    "category": "Living alone",
    "type": "Very good or good health",
    "value": 0.62
  },
  {
    "sex": "Male",
    "age": "70-74",
    "category": "Living alone",
    "type": "Very good or good health",
    "value": 0.55
  },
  {
    "sex": "Female",
    "age": "75-79",
    "category": "Living alone",
    "type": "Very good or good health",
    "value": 0.57
  },
  {
    "sex": "Male",
    "age": "75-79",
    "category": "Living alone",
    "type": "Very good or good health",
    "value": 0.52
  },
  {
    "sex": "Female",
    "age": "80-84",
    "category": "Living alone",
    "type": "Very good or good health",
    "value": 0.49
  },
  {
    "sex": "Male",
    "age": "80-84",
    "category": "Living alone",
    "type": "Very good or good health",
    "value": 0.47
  },
  {
    "sex": "Female",
    "age": "85-89",
    "category": "Living alone",
    "type": "Very good or good health",
    "value": 0.4
  },
  {
    "sex": "Male",
    "age": "85-89",
    "category": "Living alone",
    "type": "Very good or good health",
    "value": 0.4
  },
  {
    "sex": "Female",
    "age": "90+",
    "category": "Living alone",
    "type": "Very good or good health",
    "value": 0.32
  },
  {
    "sex": "Male",
    "age": "90+",
    "category": "Living alone",
    "type": "Very good or good health",
    "value": 0.35
  }
 ]